import { useState, useEffect, useCallback } from 'react';
import { cacheService } from '../services/cacheService';
import api from '../services/api';
import toast from 'react-hot-toast';

export function useOfflineSync(onSyncComplete?: () => void) {
  const [isSyncing, setIsSyncing] = useState(false);

  const syncQueue = useCallback(async () => {
    if (isSyncing || !navigator.onLine) return;

    try {
      setIsSyncing(true);
      const queue = await cacheService.getSyncQueue();

      if (queue.length === 0) {
        setIsSyncing(false);
        return;
      }

      console.log(`[OfflineSync] Iniciando sincronização de ${queue.length} itens...`);
      let syncedCount = 0;

      for (const item of queue) {
        try {
          if (item.actionType === 'POST') {
            await api.post(item.url, item.payload);
          } else if (item.actionType === 'PUT') {
            await api.put(item.url, item.payload);
          } else if (item.actionType === 'DELETE') {
            await api.delete(item.url);
          }

          // Se sucesso, remove da fila
          await cacheService.removeFromSyncQueue(item.id);
          syncedCount++;
        } catch (error: any) {
          console.error(`[OfflineSync] Erro ao sincronizar item ${item.id}:`, error);
          // Se for um erro 4xx (como validação de negócio que falhou), talvez devesse remover
          // Mas por segurança deixaremos na fila ou podemos tratar especificamente.
          // Por ora, vamos apenas continuar para o próximo.
        }
      }

      if (syncedCount > 0) {
        toast.success(`${syncedCount} pedido(s) sincronizado(s) com sucesso!`);
        if (onSyncComplete) {
          onSyncComplete();
        }
      }

    } catch (error) {
      console.error('[OfflineSync] Erro crítico durante sincronização:', error);
    } finally {
      setIsSyncing(false);
    }
  }, [isSyncing, onSyncComplete]);

  // Listener global para reconexão
  useEffect(() => {
    const handleOnline = () => {
      console.log('[OfflineSync] Conexão reestabelecida. Iniciando sync...');
      syncQueue();
    };

    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, [syncQueue]);

  return {
    isSyncing,
    syncQueue
  };
}
